import { useTranslation } from 'react-i18next';

export default function SpreadsheetSection() {
  const { t } = useTranslation('common');

  const cards = [
    { icon: 'ri-search-line', title: 'spreadsheet.card1.title', desc: 'spreadsheet.card1.desc', img: 'https://readdy.ai/api/search-image?query=Hands%20browsing%20a%20minimal%20product%20catalog%20on%20a%20tablet%20surrounded%20by%20small%20fashion%20items%20soft%20natural%20light%20clean%20editorial%20photography%20fresh%20minimal%20aesthetic%20warm%20neutral%20tones&width=600&height=400&seq=spread-find&orientation=landscape' },
    { icon: 'ri-exchange-line', title: 'spreadsheet.card2.title', desc: 'spreadsheet.card2.desc', img: 'https://readdy.ai/api/search-image?query=Two%20pairs%20of%20sneakers%20side%20by%20side%20on%20a%20light%20wooden%20table%20with%20comparison%20tags%20soft%20daylight%20minimal%20editorial%20product%20photography%20clean%20composition%20warm%20neutral%20background&width=600&height=400&seq=spread-compare&orientation=landscape' },
    { icon: 'ri-shield-check-line', title: 'spreadsheet.card3.title', desc: 'spreadsheet.card3.desc', img: 'https://readdy.ai/api/search-image?query=Person%20inspecting%20a%20product%20with%20a%20magnifying%20glass%20at%20a%20clean%20desk%20soft%20natural%20light%20minimal%20editorial%20photography%20quality%20check%20concept%20fresh%20scandinavian%20aesthetic%20warm%20tones&width=600&height=400&seq=spread-verify&orientation=landscape' },
    { icon: 'ri-check-double-line', title: 'spreadsheet.card4.title', desc: 'spreadsheet.card4.desc', img: 'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20a%20checkout%20receipt%20and%20credit%20card%20next%20to%20folded%20clothing%20on%20a%20soft%20cream%20surface%20soft%20natural%20light%20minimal%20editorial%20photography%20clean%20aesthetic%20warm%20neutral%20tones&width=600&height=400&seq=spread-decide&orientation=landscape' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            {t('spreadsheet.h2')}
          </h2>
          <p className="text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            {t('spreadsheet.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all duration-300"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={card.img}
                  alt={t(card.title)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className={`${card.icon} text-xl`} />
                </div>
                <h3 className="font-semibold text-foreground-900 mb-2">{t(card.title)}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{t(card.desc)}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            {t('spreadsheet.cta')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}